import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ArrowUpRight } from "lucide-react";
import { CONTACT_DATA } from "@/data/siteData";

export const Footer = () => {
  const footerLinks = {
    Services: [
      { label: "Software Development", to: "/software-development" },
      { label: "Entrepreneur Track", to: "/student-empowerment" },
      { label: "Placement Track", to: "/student-empowerment" },
      { label: "Events & Hackathons", to: "/student-empowerment" },
      { label: "Career Path", to: "/career-path" },
    ],
    Company: [
      { label: "About Us", to: "/about" },
      { label: "Contact Us", to: "/contact" },
    ],
    Connect: CONTACT_DATA.social.map((s) => ({
      label: s.platform,
      to: s.href,
      external: true,
    })),
  };

  return (
    <footer className="bg-[#0A0A0A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img src="/icon.png" alt="Uproot Innovation" className="h-10 w-10 object-contain" />
              <span className="font-['Outfit'] font-bold text-lg">
                Uproot <span className="text-[#3DC0E7]">Innovation</span>
              </span>
            </Link>
            <div className="space-y-3 text-sm text-slate-400">
              <div className="flex items-start gap-2">
                <MapPin size={14} className="mt-1 text-[#3DC0E7] shrink-0" />
                <span>{CONTACT_DATA.office.address}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={14} className="text-[#3DC0E7] shrink-0" />
                <span>{CONTACT_DATA.office.email}</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={14} className="text-[#3DC0E7] shrink-0" />
                <span>{CONTACT_DATA.office.phone}</span>
              </div>
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-['Outfit'] font-semibold text-sm uppercase tracking-wider text-slate-300 mb-6">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.to}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-slate-400 hover:text-[#3DC0E7] text-sm flex items-center gap-1 transition-colors duration-200"
                      >
                        {link.label}
                        <ArrowUpRight size={12} />
                      </a>
                    ) : (
                      <Link
                        to={link.to}
                        className="text-slate-400 hover:text-[#3DC0E7] text-sm transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} Uproot Innovation. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500">
            <Link to="/privacy" className="hover:text-[#3DC0E7] transition-colors duration-200">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#3DC0E7] transition-colors duration-200">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
